import React, { useEffect, useState } from 'react';

interface CountdownTimerProps {
  countDownTime: string;
  onRefresh: () => void;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ countDownTime, onRefresh }) => {
  const [timeLeft, setTimeLeft] = useState<number>(0);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const totalSeconds = parseInt(countDownTime);
      setTimeLeft(totalSeconds);
    };

    calculateTimeLeft(); // Initial calculation

    const timer = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 0) {
          onRefresh();
        }
        return prevTimeLeft - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup interval on unmount
  }, [countDownTime, onRefresh]);

  const formatTime = (seconds: number): string => {
    const days = Math.floor(seconds / (24 * 60 * 60));
    const hours = Math.floor((seconds % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((seconds % (60 * 60)) / 60);
    const secs = seconds % 60;

    if (days > 0) return `${days}d ${hours}h`;
    if (hours === 0 && minutes !== 0) return `${minutes}m ${secs}s`;
    if (hours === 0 && minutes === 0) return `${secs}s`;

    return `${hours}h ${minutes}m`;
  };

  return (
    <div>
      <p>{formatTime(timeLeft)}</p>
    </div>
  );
};

export default CountdownTimer;
